import { render } from "./MyDevices.vue?vue&type=template&id=3ca7a760"
import script from "./MyDevices.vue?vue&type=script&lang=js"
export * from "./MyDevices.vue?vue&type=script&lang=js"

import "./MyDevices.vue?vue&type=style&index=0&id=3ca7a760&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__